import { observer } from 'mobx-react';
import { action } from 'mobx';
import * as React from 'react';
import { inject } from '../../../utils/decorators';
import { UiStore } from '../../../stores/UiStore';
import Callout from '../../site/Callout';
import VorgangFormularElement from '../VorgangFormularElement';
import AgtPruefortParameter2 from './AgtPruefortParameter2';
import { Checkbox, FormControl } from 'react-bootstrap';
import { bind } from '../../../utils/decorators';
import { ApiStore } from '../../../stores/ApiStore';
import * as ApiTypes from '../../../models/ApiTypes';
import * as ApiTypesAgtPartikelzaehler from '../../../models/ApiTypesAgtPartikelzaehler';
import AgtPartikelzaehlerMessung from './AgtPartikelzaehlerMessung';
import { AgtPartikelzaehlerKalibrierungStore } from '../../../stores/AgtPartikelzaehlerKalibrierungStore';
import { VorgangStore } from '../../../stores/VorgangStore';

export interface IAgt4GaskalibrierungProps {
  elementguid: string;
  kategorieguid: string;
  editable?: boolean;
  value?: string;
  element: VorgangFormularElement;
}

/** Kapselkomponente für Messwerteingabe der Kalibrierung eines Abgasmessgerätes mit Partikelzählung */
@observer
export default class AgtPartikelzaehlerKalibrierung extends React.Component<IAgt4GaskalibrierungProps, {}> {

    @inject(UiStore) uiStore: UiStore;
    @inject(ApiStore) apiStore: ApiStore;
    @inject(VorgangStore) vorgangStore: VorgangStore;
    @inject(AgtPartikelzaehlerKalibrierungStore) kalibrierungStore: AgtPartikelzaehlerKalibrierungStore;

    abgastester: ApiTypes.IObjekt | undefined;

    constructor(props: IAgt4GaskalibrierungProps) {
      super(props);
      this.kalibrierungStore.clear();

      // Datenübernahme aus dem im Auftrag gesetzten Abgasmessgerät
      const kalGegenstand = this.kalibrierungStore.getKalibrierGegenstand();
      // In einem Auftrag können beliebige Abgasmessgeräte-Typen gemischt werden, es muss gepürft werden ob ein Partikelzähler gewählt wurde
      if (kalGegenstand && ((kalGegenstand.art === ApiTypes.AGT_PARTIKEL_DC) || (kalGegenstand.art === ApiTypes.AGT_PARTIKEL_CPC))) {
        this.abgastester = kalGegenstand;
      }

      if (this.props.value) {
        var obj = JSON.parse(this.props.value);
        // Gespeicherte Optionen
        if (obj.optionen) {
          // Justage durchgeführt
          if (obj.optionen.justage) {
            this.kalibrierungStore.setJustage(obj.optionen.justage === 'on');
          }
        }
      }

      this.kalibrierungStore.setReadOnly(this.props.editable ? !this.props.editable : true);
    }

    async componentDidMount() {
      const kalibrierGegenstand = this.kalibrierungStore.getKalibrierGegenstand();
      if (kalibrierGegenstand) {
        const objektVorlage = await this.apiStore.objektVorlage(kalibrierGegenstand.objektguid);
        if (objektVorlage.ok) {
          this.kalibrierungStore.setObjektVorlage(objektVorlage.json);
        }
        this.kalibrierungStore.setObjekt(kalibrierGegenstand);
      } else {
        this.kalibrierungStore.setObjekt(undefined);
      }

      let vorgang = this.vorgangStore.vorgang;
      if (vorgang && vorgang.arbeitsmittel) {
        // Für die Berechnung muss ein Kraftmessgerät aus dem Vorgang gewählt werden
        // @todo: aktuell wird immer die erste Normale dieses Typs gewählt (muss ggf. durch Nutzer auswählbar gemacht werden)
        var normale = vorgang.arbeitsmittel.find((e) => { return e.typ.toLowerCase() === 'agt_pck'; });
        this.kalibrierungStore.setNormale(normale);
      }

      // Falls bereits Daten zu dieser Kalibrierung gespeichert wurden, werden diese beim erneuten Anzeigen übernommen
      if (this.props.value) {
        let messung: ApiTypesAgtPartikelzaehler.IAgtPartikelzaehlerMessung = this.kalibrierungStore.datensatz;
        messung = JSON.parse(this.props.value) as ApiTypesAgtPartikelzaehler.IAgtPartikelzaehlerMessung;
        this.kalibrierungStore.setMesswerte(messung);
      }
      this.kalibrierungStore.setReadOnly(this.props.editable ? !this.props.editable : true);
    }

    @bind @action handleJustageChange(ev: React.FormEvent<FormControl>) {
      this.kalibrierungStore.setJustage((ev.target as HTMLInputElement).checked);
    }

    public renderMessReihe(nachJustage: boolean) {
      let zielArray = nachJustage ? this.kalibrierungStore.datensatz.messreihenJustage : this.kalibrierungStore.datensatz.messreihen;

      return (
        <div>
          <AgtPartikelzaehlerMessung nennwert={400000} ziel={zielArray[0]} nachjustage={nachJustage}/>
          <AgtPartikelzaehlerMessung nennwert={250000} ziel={zielArray[1]} nachjustage={nachJustage}/>
          <AgtPartikelzaehlerMessung nennwert={50000} ziel={zielArray[2]} nachjustage={nachJustage}/>
        </div>
      );
    }

    public render() {
      // Wenn bereits Werte erfasst wurden, in jeweiligen Komponenten übernehmen
      let parameter = undefined;
      if (this.props.value) {
        var obj = JSON.parse(this.props.value);
        if (obj.parameter) {
          parameter = obj.parameter;
        }
      }

      if (this.abgastester === undefined) {
        return (
          <Callout bsStyle="danger">
            <p>Für die Erstellung der Auswertung muss ein Partikelzählgerät ausgewählt werden.</p>
          </Callout>
        );
      }

      if (this.kalibrierungStore.normale === undefined) {
        return (
          <Callout bsStyle="danger">
            <p>Für die Erstellung der Auswertung muss ein PCK als Messmittel ausgewählt werden.</p>
          </Callout>
        );
      }

      return(
        <div>
          <AgtPruefortParameter2
            titel="Prüfortparameter zu Beginn der Kalibrierung"
            ziel={this.kalibrierungStore.datensatz.pruefortparameter.beginn}
            readOnly={this.kalibrierungStore.readOnly}/>

          {this.renderMessReihe(false)}

          {/* Optionale Eingabe nach Justage (wenn notwendig) */}
          <Callout bsStyle="default">
            <Checkbox
              inline={true}
              id="checkbox_justage"
              disabled={!this.props.editable}
              onChange={this.props.editable ? this.handleJustageChange : undefined}
              checked={this.kalibrierungStore.datensatz.justage}
            >
              Justage durchgeführt
            </Checkbox>
            <div className="text-hint-light">
                Zeigt eine zweite Messwerteingabe für die Erfassung der Daten nach Durchführung einer Justage an. Beim Erzeugen des Kalibrierscheins werden diese Messwerte übernommen.
            </div>
          </Callout>

          {this.kalibrierungStore.datensatz.justage &&
              this.renderMessReihe(true)
          }

          {/* Prüfortparameter dieser Art funktionieren nicht mit einem gobalen Store, müssen also angepasst werden */}
          <AgtPruefortParameter2
            titel="Prüfortparameter am Ende der Kalibrierung"
            ziel={this.kalibrierungStore.datensatz.pruefortparameter.ende}
            readOnly={this.kalibrierungStore.readOnly}/>

          {/* Die Messdaten müssen zum Speichern ans Back-End übergeben werden, dazu verwenden wir ein verstecktes Feld im Request übergeben */}
          <FormControl type="hidden" name={`${this.props.kategorieguid}[${this.props.elementguid}][json]`} value={JSON.stringify(this.kalibrierungStore.datensatz)}/>
        </div>
      );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/agt/AgtPartikelzaehlerKalibrierung.tsx